import React, { Component } from "react";
import COLORS from "scss/colors.module.scss";
import moment from "moment";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { DIMENSIONS } from "utils/Dimensions";
import styled from "styled-components";
import ApiClient from "utils/ApiClient";
import { TextField, IconButton, Tooltip, Menu, MenuItem } from "@material-ui/core";
import AlternateEmail from "@material-ui/icons/AlternateEmail";
import { handleCommentsData } from "app/websocketManager/eventEmitter";
export default class CommentsIdColumnEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.getDefaultValue(this.props) || "",
      commentsData: [],
      anchorElMentions: null,
      mentions: [],
      isFocused: false,
    };
    this.arrowKeyNavigation = this.arrowKeyNavigation.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleMentions = this.handleMentions.bind(this);
  }

  handleMentions = (address) => {
    if (typeof address == "string") {
      this.setState({ value: this.state.value + ` @${address}` })
    }
  };

  getDefaultValue(props) {
    if (props.data.row_id) {
      return props.charPress ? props.charPress : "";
    }
  }

  handleChange = async (value, id = -1) => {
    if (this.props.colDef.store.isLazyLoadEnabled) {
      this.props.colDef.store.isCurrentRowSaving = true;
    }
    // this.props.onChange(value);
    this.setState({ value: value });
  };

  fetchComments = async () => {
    try {
      const res = await ApiClient.Comments.getComments({
        list_id: this.props.colDef.store.listId,
        row_id: this.props.data.row_id,
        page: 1,
        start: 0,
        limit: 1000,
        is_web: 1,
      });
      return res.data;
    } catch (e) {
      return [];
    }
  };

  async saveAndRedrawRows() {
    if(!this.state.value){
      return;
    }
    var currentDate = new Date();
    const currentOffset = new Date().getTimezoneOffset();
    const offsetDifference = -330;
    const final = currentOffset - offsetDifference
    currentDate.setMinutes(currentDate.getMinutes() + final);
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formattedDate = currentDate.toLocaleString('en-US', { timeZone: timeZone })
      .replace(/T/, ' ')
      .replace(/\..+/, '');
    const newCommentsObject = {
      description: this.state.value,
      created_at: formattedDate,
      created_by_name: window.appStore.userStore.user.full_name,
    };
    this.props.colDef.store.isCommentsColumnSaving = true;
    this.props.colDef.store.comments[this.props.data.row_id] = (this.props.colDef.store.comments[this.props.data.row_id] === 0 || this.props.colDef.store.comments[this.props.data.row_id] === '' || this.props.colDef.store.comments[this.props.data.row_id] === undefined) ? 1 : Number(this.props.colDef.store.comments[this.props.data.row_id]) + 1;
    this.props.data.comments.push(newCommentsObject);
    await this.props.colDef.store.gridApi?.redrawRows({ rowNodes: [this.props.node] });
    await this.saveComment();
    this.setState({ value: "" });
    let comData = await this.fetchComments();
    comData = comData.slice().reverse()
    this.props.colDef.store.comments[this.props.data.row_id] = comData.length;
    this.props.data.comments = comData;
    await this.props.colDef.store.gridApi?.redrawRows({ rowNodes: [this.props.node] });
    setTimeout(() => {
      this.props?.colDef?.store?.currentCommentsElement?.click();
    }, 500);
    this.props.colDef.store.isCommentsColumnSaving = false;
    handleCommentsData(JSON.stringify(comData), comData.length, this.props.data.row_id, this.props.data.uniqueId , this.props.colDef.store.listId);
  }

  async componentDidMount() {
    this.fetchMentions();
    if (this.props?.data?.comments &&
      Array.isArray(this.props.data.comments)) {
      this.setState({ commentsData: this.props.data.comments })
    }
    else {
      const { listId } = this.props.colDef.store;
      const { row_id } = this.props.data;
      let res = await ApiClient.Comments.getComments({
        list_id: listId,
        row_id: row_id,
        page: 1,
        start: 0,
        limit: 1000,
        is_web: 1,
      });
      this.setState({ commentsData: res.data })
    }
    this.refs.container.addEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
    this.focus();
  }

  async componentWillUnmount() {
    setTimeout(() => {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }, 200);
    this.props.colDef.store.currentCommenteGridCell = null;
    this.refs.container.removeEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
    try {
      this.refs.container.offsetParent.style.bottom = "";
    } catch (e) { }
  }

  saveComment = async (id = -1) => {
    const { listId } = this.props.colDef.store;
    const { row_id } = this.props.data;
    const { value } = this.state;
    if (!value.trim()) {
      // If the comment is empty, return without saving
      return;
    }

    let body = {
      list_id: listId,
      row_id: row_id,
      description: value,
      is_web: 1,
      comment_id: id,
      from_sheet: true
    };
    await ApiClient.Comments.save(body);
  };

  fetchMentions = async () => {
    try {
      const { listId } = this.props.colDef.store;
      const resp = await ApiClient.Comments.getListMentions({
        list_id: listId,
        is_web: 1,
      });
      this.setState({ mentions: resp.data })
    } catch (error) {
    }
  };

  async arrowKeyNavigation(event) {
    if ([13].indexOf(event.keyCode) > -1) {
      event.stopPropagation();
    }
    if (event.shiftKey && event.code === "Enter" || event.keyCode === 9) {
      event.preventDefault();
      await this.saveAndRedrawRows();
      if (event.shiftKey && event.code === "Enter") {
        this.focusNextCell();
      } else {
        this.props.api.clearFocusedCell();
        this.props.api.clearRangeSelection();
        const currentColumnId = this.props.column.colId;
        const columnDefs = this.props.api.getColumnDefs();
        const currentIndex = columnDefs.findIndex(colDef => colDef.colId === currentColumnId);
        const nextColumnId = currentIndex < columnDefs.length - 1 ? columnDefs[currentIndex + 1].colId : null;
        this.props.api.setFocusedCell(
          this.props.rowIndex,
          nextColumnId,
        );
        this.props.api.startEditingCell({
          colKey: nextColumnId,
          rowIndex: this.props.rowIndex,
        });
      }
    }
  }

  focusNextCell = (
    rowIndex = this.props.rowIndex + 1,
    colId = this.props.column.colId
  ) => {
    this.props.api.clearRangeSelection();
    this.props.api.stopEditing();
    this.props.colDef.store.addRowOnGrid(
      rowIndex,
      this.props.node.id,
      this.props.context,
      colId
    );
    setTimeout(() => {
      this.props.api.setFocusedCell(rowIndex, colId);
    }, 10);
  };

  focus() {
    window.setTimeout(() => {
      if (this.inputRef) {
        this.inputRef.focus();
        this.inputRef.value = "";
        this.inputRef.value = this.state.value;
        document.addEventListener("mousedown", this.handleClickOutside);
      }
    }, 10);
    const src = this.props?.colDef?.store?.currentCommenteGridCell;
    if (src) { // Check if src exists
      src.style.position = "";
      src.style.bottom = "";
      const srcTop = src.getBoundingClientRect().top;
      if (window.innerHeight - srcTop < 317) {
        if ((this.props.node.rowIndex + 1) * this.props.node.rowHeight < 250) {
          let newBottom = 250 - (this.props.node.rowIndex + 1) * this.props.node.rowHeight;
          src.style.position = "absolute";
          src.style.bottom = `-${newBottom + 4}px`;
        } else {
          // These will only get applied if the inner condition is false
          src.style.position = "absolute";
          src.style.bottom = "0px";
        }
      }
    }
  }
  handleClickOutside(event) {
    if (event.target.closest(".comments_mentions")) {
      return;
    }
    const commentsRef = this.wrapperRef;
    if (commentsRef && !commentsRef.contains(event.target) && !this.menuButtonRef?.contains(event.target)) {
      if (this.state.value.trim() !== "") {
        this.saveAndRedrawRows();
      }
      document.removeEventListener("mousedown", this.handleClickOutside);
      this.props.api.clearFocusedCell();
      this.props.api.clearRangeSelection();
    }
  }


  setWrapperRef(node) {
    setTimeout(() => {
      this.wrapperRef = node;
    }, 600);
  }

  isPopup() {
    return false;
  }

  render() {
    const { isFocused } = this.state;
    let borderStyle = isFocused ? { border: '2px solid #237ff4' } : { border: '1px solid #ccc' };
    const commentsArray = [];
    if (
      this.state.commentsData &&
      Array.isArray(this.state.commentsData)
    ) {
      this.state.commentsData.forEach((commentObject, i) => {
        const { description, created_at, created_by_name } = commentObject;
        const istDate = new Date(created_at);
        const finalDate = this.props.colDef.store.convertIstToCurrentTimeZone(istDate)
        // const formattedDate = (
        //   <Tooltip title={moment(finalDate).format("DD-MMM-YY HH:mm a")}>
        //     <span style={{ fontSize: '9px' }}>
        //       {moment(finalDate).fromNow()}
        //     </span>
        //   </Tooltip>
        // );
        const createdByAndDate = (
          <Tooltip title={moment(finalDate).format("DD-MMM-YY HH:mm a")}>
            <CreatedByAndDate>
              {created_by_name}
              <DateText>{moment(finalDate).fromNow()}</DateText>
            </CreatedByAndDate>
          </Tooltip>
        );
        const formattedComment = (
          <CommentContainer>
            <CommentNumbering index={i + 1}>{i + 1}</CommentNumbering>
              <CommentText>
                {description}
              </CommentText>
              <CreatedByAndDateDiv width={this.props.colDef.width}>
                {createdByAndDate}
              </CreatedByAndDateDiv>
          </CommentContainer>
        );
        commentsArray.push(formattedComment);
      });
    }
     return (
      <div
        ref={this.setWrapperRef}
        style={{
          height: "250px",
          display: 'flex',
          flexDirection: 'column',
          overflowY: "auto",
          overflowX:"hidden",
          width: Number(this.props.colDef.width) - 3
        }}
      >
        <div
          ref="container"
          style={{
            background: COLORS.PRIMARY_COLOR,
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
          }}
        >
          <BorderStyles isFocused={this.state.isFocused}>
            <TextField
              inputRef={(ref) => { this.inputRef = ref; }}
              rowsMax={4}
              rows={2}
              multiline
              autoFocus
              margin="none"
              value={this.state.value}
              placeholder="Enter your comment here"
              className="commentsTextArea"
              InputProps={{
                disableUnderline: true,
              }}
              style={{
                ...styles.input,
                width: "96%",
                height: DIMENSIONS.multiline_expanded_height - 15,
                height: 'auto',
                fontSize: "13px",
                padding: "6px 0px 0px 0px",
                border: 'none',
                marginLeft: '6px'
              }}
              onFocus={() => this.setState({ isFocused: true })}
              onBlur={() => this.setState({ isFocused: false })}
              onChange={(e) => {
                this.handleChange(e.target.value);
              }}
            />
            <div 
            style={{
              lineHeight: '15px',
              justifyContent: 'flex-end',
              display: 'flex'
            }}
            >
              <IconButton
                ref={(ref) => { this.menuButtonRef = ref; }}
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={(event) => {
                  this.setState({ anchorElMentions: event.currentTarget })
                }}
                style={{ backgroundColor: 'transparent !important', padding: '5px', marginRight: '5px' }}
              >
                <Tooltip title="Mentions: Tag a user to trigger email notifications and keep them informed when mentioned in comments." >
                  <AlternateEmail style={{ fontSize: '16px' }} />
                </Tooltip>
              </IconButton>
              <Menu
                id="long-menu"
                ref={(ref) => { this.menuRef = ref; }}
                anchorEl={this.state.anchorElMentions}
                keepMounted
                open={Boolean(this.state.anchorElMentions)}
                onClose={() => this.setState({ anchorElMentions: null })}
                className="comments_mentions"
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                PaperProps={{
                  style: {
                    maxHeight: 48 * 4.5,
                    overflowY: "auto",
                  },
                }}
              >
                {this.state.mentions.map((el) => {
                  return (
                    <MenuItem
                      key={Math.random()} onClick={
                        () => this.handleMentions(el.address)}>
                      {el.address}
                    </MenuItem>
                  );
                })}
              </Menu>
            </div>
          </BorderStyles>
          <div>
            <List className="commentStyles" style={{ padding: 0 }}>
              {commentsArray.reverse().map((comment, index) => (
                <ListItem key={index} style={{ padding: 0, backgroundColor: index % 2 === 0 ? '#f9fafb' : '#ffffff' }}>
                  <div>{comment}</div>
                </ListItem>
              ))}
            </List>
            <StyledFixedDiv className="commentsExtraText">Shift+Enter or Tab to save</StyledFixedDiv>
          </div>
        </div>
      </div>

    );
  }
}

const styles = {
  input: {
    // paddingLeft: 10,
    // paddingRight: 25,
    backgroundColor: COLORS.PRIMARY_COLOR,
    resize: "none",
    lineHeight: "1.5em",
    fontSize: 13,
    color: COLORS.TEXT_COLOR,
    fontFamily: "Roboto, sans-serif",
  }
};

const StyledFixedDiv = styled.div`
  position: sticky;
  background-color: #fff;
  width:100%;
  bottom: -1px !important;
  padding-bottom: 0px !important;
  padding-top: 0px !important;
`;

const CreatedByAndDate = styled.span`
  padding: 9px;
  border-radius: 20px;
  text-align: center;
  align-items: center;
  overflow: hidden;
  background-color: #e7e7e7;
  color: #4e4e4e;
  line-height: 0px;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 5px;
  cursor: pointer;
  max-width: 95%;
`;

const CommentNumbering = styled.span`
  display: inline-block;
  vertical-align: text-top;
  background-color: #3f51b5;
  color: white;
  border-radius: 50%;
  text-align: center;
  margin-right: 5px;
  font-size: 9px;
  width: ${({ index }) => (index >= 100 ? '20px' : (index >= 10 ? '17px' : '15px'))};
  height: ${({ index }) => (index >= 100 ? '20px' : (index >= 10 ? '17px' : '15px'))};
  line-height: ${({ index }) => (index >= 100 ? '20px' : (index >= 10 ? '17px' : '15px'))};
`;

const BorderStyles = styled.span`
  border-radius: 4px;
  margin: 7px;
  border: ${({ isFocused }) => (isFocused ? '2px solid #237ff4' : '1px solid #ccc')};
`;

const DateText = styled.span`
  font-size: 9px;
  margin-left: 2px;
`;

const CommentContainer = styled.div`
  margin-bottom: 5px;
  display: inline-block;
  vertical-align: text-top; 
  padding: 6px;
`;

const CommentText = styled.div`
display: inline-block; 
max-width: calc(100% - 30px);
vertical-align: top;
`;

const CreatedByAndDateDiv = styled.span`

  align-items: center;
  max-width: 95%;
  margin-top: 5px;
  display: flex;
  width: ${props => Number(props.width) - 10}px;
`;
